import React, { useState, useEffect } from "react";
import YouTube from 'react-youtube';

const YoutubeEmbed = (props) => {
    const { cogLoad } = props;
    const { embedId } = props;
    const [player, setPlayer] = useState(null);
    const [timeLeft, setTimeLeft] = useState(1200)

    const opts = {
        height: '480',
        width: '640',
        playerVars: {
            autoplay: 1,
        },
    };

    useEffect(() => {
        console.log(cogLoad);
        if (player !== null){
            if (cogLoad === 'vvl') {
                player.playVideo();
            } else {
                player.pauseVideo();
            }
        }
    }, [cogLoad]);

    useEffect(() => {
        let timediff = 1;
        if (player !== null && player.getPlayerState() === 2) {
            timediff = 0;
        }

        if (!(timeLeft > 0)){
            player.pauseVideo();
            setTimeLeft(1200);
        }

        timeLeft > 0 && setTimeout(() => setTimeLeft(timeLeft - timediff), 1000);
    }, [timeLeft]);

    const _onReady = (event) => {
        setPlayer(event.target);
        setTimeLeft(1200);
    }

    return(
        <div className = "video-responsive">
            <YouTube videoId={embedId} opts={opts} onReady={_onReady} />
        </div>
    );
    
}


export default YoutubeEmbed;